import { render, staticRenderFns } from "./ComponentDetailModal.vue?vue&type=template&id=51ffc5c1&scoped=true"
import script from "./ComponentDetailModal.vue?vue&type=script&lang=js"
export * from "./ComponentDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ComponentDetailModal.vue?vue&type=style&index=0&id=51ffc5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffc5c1",
  null
  
)

export default component.exports